import * as types from './actionTypes';

export const setFeedbackMessageAction = (message: string) => (
  {
    type: types.SET_FEEDBACK_MESSAGE,
    payload: message
  }
)
export const setFeedbackMessageVariantAction = (variant: 'success' | 'error' | 'info' | 'warning') => (
  {
    type: types.SET_FEEDBACK_MESSAGE_VARIANT,
    payload: variant
  }
)
export const openFeedbackMessageAction = () => (
  {
    type: types.OPEN_FEEDBACK_MESSAGE,
  }
)
export const closeFeedbackMessageAction = () => (
  {
    type: types.CLOSE_FEEDBACK_MESSAGE,
  }
)





// WEBPACK FOOTER //
// ./src/modules/core/actions/actions.tsx